<template>
  <div>
    <div class="is-size-4 m-3" v-katex="katex_formula"></div>
    <table class="table is-striped is-hoverable is-size-7-mobile mb-5">
      <tbody>
        <tr class="is-size-7-mobile" v-for="(variable, index) in variables" :key="index">
          <td><i class="fas fa-arrow-right"></i></td>
          <td>
            <VariableLabelString :label="variable.label" :has_desc="false" />
          </td>
          <td>...</td>
          <td>
            <VariableLabelString :label="variable.label" :has_short="false" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import VariableLabelString from '@/components/VariableLabelString.vue'

export default {
  name: 'FormulaDescription',
  components: {
    VariableLabelString
  },
  props: {
    katex_formula: { type: String, required: true },
    variables: { type: Array, required: true }
  }
}
</script>
